    import {Workbox} from 'workbox-window'
    // import {bus} from './main.js'
    // import Vue from "vue";
    // export const bus = new Vue()
    let wb
    let contosoChatHubProxy
    let notif_center
    let broadcast
    let messageChannel
    if ('serviceWorker' in navigator) {
      wb = new Workbox(`${process.env.BASE_URL}service-worker.js?${process.env.VUE_APP_APP_VERSION}`)
      wb.addEventListener('controlling', () => {
        window.location.reload()
      })
      wb.addEventListener('message', (event) => {

        if (event.data && event.data.type === 'MESSAGE_IDENTIFIER') {
          // do something
        }
      });
      wb.register().then(registration => {
        notif_center = registration;
      })
    } else {
      wb = null
    }
    if (1 == 0) {//disable broadcas channel
      try {
        broadcast = new BroadcastChannel('count-channel');
        broadcast.onmessage = (event) => {
          if (event.data && event.data.type === 'SignalInvoke') {
            // broadcast.postMessage({ payload: ++count });
            var json_obj = JSON.parse(event.data.data)
            signalr_invokes(json_obj.method, json_obj.data)
          }
        };
      } catch {
        console.log("broadcast not support in sw")
      }
    }

    try {
      messageChannel = new MessageChannel();

      addEventListener('message', (event) => {
        // console.log("message channel received in sw",event)

        if (event.data && event.data.type === 'SignalInvoke') {
          // broadcast.postMessage({ payload: ++count });
          var json_obj = JSON.parse(event.data.data)
          signalr_invokes(json_obj.method, json_obj.data)
        }
      });
    } catch (e) {
      console.log("message channel not support  in sw")
    }

    function postMsgChannel(message) {
      // console.log("post msg channel run",message)
    //       try{
    //         broadcast.postMessage(message);
    //       }catch (e) {
    // console.log("broadcast channel message error send")
    //       }
      try {
        // this.messageChannel.postMessage(message);
        postMessage(message);

      } catch (e) {
        console.log("message channel message error send", e)

      }
    }

    function config_signalr() {
      //listen to messages
      // bus.$on('signalr_invokes', (json_data) => {
      //   var json_obj = JSON.parse(json_data)
      //   console.log('signalr_invokes', json_data)
      //   signalr_invokes(json_obj.method, json_obj.data)
      // })
      $.connection.hub.url = 'https://panel.zoodkomak.com/signalr'

      contosoChatHubProxy = $.connection.zoodKomakHub
      console.log(contosoChatHubProxy)

      contosoChatHubProxy.client.getMessages = function (message) {
        console.log('get message', message)
        // bus.$emit('signalr_methods', ['get_message', message])
        postMsgChannel({
          type: 'BroadcastToBus',
          event: 'signalr_methods',
          args: ['get_message', message]
        });

        var user_data = localStorage.getItem('userId2')
        if (message.CurrentUserId != user_data) {
          const options = {
            body: "یک پیام جدید از " + message.UserName,
            icon: '/img/icons/logo.png',
            vibrate: [100, 50, 100],
            data: {
              dateOfArrival: Date.now(),
              primaryKey: 0
            }
          };

          // new Notification('پیام جدید', options)
          notif_center.showNotification('زود کمک', options)
        }
      }
      contosoChatHubProxy.client.GetNotifFromNewZk = function (message) {
        console.log('new notif zoodkomak', message)
        var json_mesage = JSON.parse(message)
        if (json_mesage.func == 'online_request_confirmed') {
          var message = 'درخواست ' + json_mesage.data.request.type_name + ' ' + json_mesage.data.request.group_name + ' ' + json_mesage.data.request.subgroup_name + ' ' +
            ' توسط ' + json_mesage.data.user.name + ' تایید شد.'
          // bus.$emit('show_dialog', ['درخواست شما تایید گردید', message])
          // bus.$emit('online_request_updated', true)
          postMsgChannel({
            type: 'BroadcastToBus',
            event: 'show_dialog',
            args: ['درخواست شما تایید گردید', message]
          });
          postMsgChannel({
            type: 'BroadcastToBus',
            event: 'online_request_updated',
            args: true
          });
        }
        if (json_mesage.func == 'online_request_canceled') {
          var message = 'متاسفانه برای درخواست ' + json_mesage.data.request.type_name + ' ' + json_mesage.data.request.group_name + ' ' + json_mesage.data.request.subgroup_name + ' ' +
            ' کارشناسی یافت نشد '
          // bus.$emit('show_dialog', ['درخواست لغو گردید', message])
          // bus.$emit('online_request_updated', true)
          postMsgChannel({
            type: 'BroadcastToBus',
            event: 'show_dialog',
            args: ['درخواست لغو گردید', message]
          });
          postMsgChannel({
            type: 'BroadcastToBus',
            event: 'online_request_updated',
            args: true
          });
        }

        // bus.$emit('signalr_methods', ['get_message', message])
      }
      contosoChatHubProxy.client.MessagesNotRead = function (message) {
        // console.log("MessagesNotRead", message);
      }
      contosoChatHubProxy.client.GetInboxRead = function (message) {
        console.log('GetInboxRead', message)
        // bus.$emit('signalr_methods', ['read_message', message])
        postMsgChannel({
          type: 'BroadcastToBus',
          event: 'signalr_methods',
          args: ['read_message', message]
        });
      }
      contosoChatHubProxy.client.UserFired = function (message) {
        // console.log("UserFired", message);
      }
      contosoChatHubProxy.client.GetIsTyping = function (message) {
        // console.log( message);
        // bus.$emit('signalr_methods', ['is_typing', message])
        postMsgChannel({
          type: 'BroadcastToBus',
          event: 'signalr_methods',
          args: ['is_typing', message]
        });
      }
      contosoChatHubProxy.client.GetUserOnlineStatus = function (message) {
        // console.log("GetUserOnlineStatus", message);
      }
      contosoChatHubProxy.client.getTechTrackInfo = function (message) {
        // console.log( message);
      }

      start_hub_connection()
    }

    function start_hub_connection() {
      var self = this
      $.connection.hub.start()
        .done(function () {
          console.log('Now connected, connection ID=' + $.connection.hub.id)
          var user_data = JSON.parse(localStorage.getItem('profile'))
          var userId = user_data.UserId
          signalr_invokes('connect', '{"userId":"' + userId + '"}')
        })
        .fail(function () {
          console.log('Could not Connect!')
        })

      $.connection.hub.stateChanged(function (change) {
        if (change.newState === $.signalR.connectionState.reconnecting) {
          // console.log('Server has reconecting');
        } else if (change.newState === $.signalR.connectionState.connected) {
          // console.log('Server has connected');
        } else if (change.newState === $.signalR.connectionState.disconnected) {
          // console.log('Server has dis111connected');
          setTimeout(function () {
            $.connection.hub.start()
          }, 1000)
        }
      })
    }

    function signalr_invokes(method, args) {
      if (method == 'connect') {
        contosoChatHubProxy.server.connect(args).done(function () {
          console.log('Invocation of connect succeeded')
        }).fail(function (error) {
          console.log('Invocation of connect failed. Error: ' + error)
        })
      }
    //* ***********************************************
      if (method == 'send_message') {
        contosoChatHubProxy.server.sendMessageToGroup(args).done(function () {
          console.log('Invocation of send_message succeeded ')
        }).fail(function (error) {
          console.log('Invocation of send_message failed. Error: ' + error)
        })
      }
    //* ***********************************************
      if (method == 'is_typing') {
        contosoChatHubProxy.server.sendIsTyping(args).done(function () {
          console.log('Invocation of is_typing succeeded', args)
        }).fail(function (error) {
          console.log('Invocation of is_typing failed. Error: ' + error)
        })
      }
      //* ***********************************************
      if (method == 'delete_connection') {
        contosoChatHubProxy.server.deleteConnection(args).done(function () {
          console.log('Invocation of delete_connection succeeded')
        }).fail(function (error) {
          console.log('Invocation of delete_connection failed. Error: ' + error)
        })
      }
    //* ***********************************************
      if (method == 'delete_connection') {
        contosoChatHubProxy.server.deleteConnection(args).done(function () {
          console.log('Invocation of delete_connection succeeded')
        }).fail(function (error) {
          console.log('Invocation of delete_connection failed. Error: ' + error)
        })
      }
    //* ***********************************************
      if (method == 'add_online') {
        contosoChatHubProxy.server.addUserOnline(args).done(function () {
          console.log('Invocation of add_online succeeded')
        }).fail(function (error) {
          console.log('Invocation of add_online failed. Error: ' + error)
        })
      }
    //* ***********************************************
      if (method == 'send_read') {
        contosoChatHubProxy.server.addToInboxRead(args).done(function () {
          console.log('Invocation of add_online succeeded')
        }).fail(function (error) {
          console.log('Invocation of add_online failed. Error: ' + error)
        })
      }
    //* ***********************************************
    }

    config_signalr()

    // const filesToCache = [
    //   'views/messenger/ChatDetail.vue',
    //
    // ];
    //
    // const staticCacheName = 'pages-cache-v1';
    //
    // self.addEventListener('install', event => {
    //   console.log('Attempting to install service worker and cache static assets');
    //   event.waitUntil(
    //     caches.open(staticCacheName)
    //       .then(cache => {
    //         return cache.addAll(filesToCache);
    //       })
    //   );
    // });
    export default wb
